import type { FC } from "react";
import { useMemo } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import Chart from "pro-features/components/Chart/src/Chart";
import { IndustryOverviewLoader } from "app/pages/industry-analysis/overview/components/common/IndustryOverviewLoader/IndustryOverviewLoader";

import { DeviceDistributionChartNoData } from "../../../../components/DeviceDistributionChartNoData/DeviceDistributionChartNoData";
import { getPieChartConfig, getPieChartStyle } from "../../config/chartConfigUtils";
import type { IDeviceDistributionPieChartSeries } from "../../types";
import { ChartLegend } from "../ChartLegend/ChartLegend";

interface IChartBodyProps {
    isLoading: boolean;
    onMouseOverChart: (e: unknown) => void;
    onMouseOutChart: () => void;
    data: IDeviceDistributionPieChartSeries[];
    activeLegendItem: string;
}

export const ChartBody: FC<IChartBodyProps> = (props) => {
    const { data, onMouseOverChart, onMouseOutChart, isLoading, activeLegendItem } = props;

    const PieChart = useMemo(() => {
        return (
            <Chart
                type="pie"
                data={[{ data: data }]}
                config={getPieChartConfig(onMouseOverChart, onMouseOutChart)}
                domProps={getPieChartStyle()}
            />
        );
    }, [data, onMouseOverChart, onMouseOutChart]);

    if (isLoading) {
        return <IndustryOverviewLoader />;
    }

    if (!data || data.length <= 0) {
        return <DeviceDistributionChartNoData />;
    }

    return (
        <>
            <Flex
                justifyContent="center"
                alignItems="center"
            >
                {PieChart}
            </Flex>
            <ChartLegend
                items={data}
                focusedItemName={activeLegendItem}
            />
        </>
    );
};
